module.exports = __webpack_public_path__ + "img/symbol_8.e2264cc4.png";